/**
 * Fasto Sathi — LLM configuration.
 *
 * Sathi rides on `page-agent` (github.com/alibaba/page-agent), which talks to
 * any OpenAI-compatible chat-completions endpoint. All requests go through
 * our own backend gateway (`/svc/llm/v1`, same-origin): the browser
 * authenticates with the user's normal Django JWT and the provider API key
 * stays server-side (backend OPENAI_API_KEY / LLM_BASE_URL env).
 *
 * Only the model is chosen at build time; when it's missing the launcher
 * simply doesn't render — a broken assistant button is worse than no button.
 */

/** Same-origin backend LLM gateway (see backend/app/routers/llm.py). */
export const LLM_PROXY_BASE_URL = '/svc/llm/v1';

export const sathiLLM = {
  baseURL: LLM_PROXY_BASE_URL,
  model: import.meta.env.VITE_SATHI_LLM_MODEL?.trim() ?? '',
};

export function isSathiConfigured(): boolean {
  return Boolean(sathiLLM.model);
}
